import { InfrastructureForm } from "features/CenterContent/RoleContent/TrainMap/StretchBuilder/infrastructureEvents/types/formSchema";
import { FC } from "react";
import { useFormContext } from "react-hook-form";
import { useTranslation } from "react-i18next";
import { Select } from "shared/components/forms/Select";

export enum InfrastructureProviderEnum {
  BANE_NOR = "BANE_NOR",
  TRAFIKVERKET = "TRAFIKVERKET",
  NONE = "NONE",
}

type InfrastructureProviderProps = {
  isPlanned: boolean;
};

export const InfrastructureProvider: FC<InfrastructureProviderProps> = ({
  isPlanned,
}) => {
  const { register } = useFormContext<InfrastructureForm>();
  const { t } = useTranslation();
  return (
    <Select
      label={t("Infrastrukturleverandør")}
      {...register(`infrastructureForm.infrastructureProvider`)}
    >
      <option value={InfrastructureProviderEnum.BANE_NOR}>Bane NOR</option>
      <option value={InfrastructureProviderEnum.TRAFIKVERKET}>
        Trafikverket
      </option>
      {!isPlanned && (
        <option value={InfrastructureProviderEnum.NONE}>Ingen</option>
      )}
    </Select>
  );
};
